import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Employee } from '@models/Models';

interface EmployeeCompProps {
    item: Employee,
    selectedTeam: string[],
    onRemove: (id: string) => void
    onAdd: (id: string) => void
}

const EmployeeComp: React.FC<EmployeeCompProps> = ({ item, selectedTeam, onRemove, onAdd }) => {
    const isSelected = selectedTeam?.some(emp => emp === item.id);

    return (
        <Row className='mb-2 gap-2'>
            <Col className='myBorder p-2 text-center bg-white'>
                <span className='text-black'>{item.firstName}  {item.lastName}</span>
            </Col>
            <Col className='myBorder p-2 text-center bg-white'>
                <span className='text-black'>{item.phone}</span>
            </Col>
            <Col xs={1} className='d-flex justify-content-center align-items-center'>
                <Form.Check
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => {
                        if (isSelected) {
                            onRemove(item.id as string);
                        } else {
                            onAdd(item.id as string);
                        }
                    }}
                />
            </Col>
        </Row>
    )
}

export default EmployeeComp